/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_FinanceInputs */

const en_waiting_on_finance = /** @type {(inputs: Waiting_On_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on Finance`)
};

/**
* | output |
* | --- |
* | "Waiting on Finance" |
*
* @param {Waiting_On_FinanceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_finance = /** @type {((inputs?: Waiting_On_FinanceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_FinanceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_finance(inputs)
});